/* eslint-disable no-param-reassign, import/no-cycle */

import $api from '@/utils/api';
import _ from 'lodash';
import moment from 'moment';
import $router from '@/router/index';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';

function getTimeSpanByPeriod(periodYear, period, year) {
    const startTime = moment(period * 2 - 1, 'MM').year(year || periodYear);
    const endTime = moment(period * 2, 'MM')
        .year(year || periodYear)
        .endOf('month')
        .endOf('day');
    return [startTime.format('x'), endTime.format('x')];
}

function getDiscountValidateCode(number, date) {
    if (!number || !date) return undefined;
    const isIncome = true;
    const fooMonth = moment(date).month() + 1;
    const fooYear = moment(date).year();
    const fooKey = `${number[0]}${number[1]}`;
    const TYPE = _.chain(invoiceSerialNumber)
        .filter(['year', fooYear])
        .find((o) => o.month.includes(fooMonth))
        .get('datas')
        .find((o) => o.serialNumbers.includes(fooKey))
        .get('name')
        .value();
    const TYPE_CODE = { A: 3, B: 4, D: 3 };
    if (TYPE) return `${isIncome ? 3 : 2}${TYPE_CODE[TYPE]}`;
    return undefined;
}

// ======================================================================

const states = {
    isReady: false,
    isLoading: false,
    datas: [],
    periodList: [],

    // Queries
    timespan: null,
    period: null,
    periodYear: null,
    keyword: null,
    totalDataCount: 0,
    queryParams: {
        SearchType: 1, // 1: 發票日期, 2: 申報日期
        QueryType: 1, // 1: 發票收入(銷項), 2: 請款支出(進項)
        StartDate: null,
        EndDate: null,
        PageSize: 25,
        PageNum: 1,
        Year: null,
        Month: null,
        Foo: null,
        Bsn: null,
        Amt: null,
        TaxDeclareStatus: 1,
    },

    //
    currentTableVueComponent: null,
    selectedItems: [],
    selectedInvoiceItems: [],
    selectedPaymentItems: [],

    //
    dataCount: {
        undeclared: 0,
        declared: 0,
        other1: 0,
        other2: 0,
    },
    dataStatistic: {
        invoiceTaxSum: 0,
        invoiceUntaxAmtSum: 0,
        invoiceDiscountTaxSum: 0,
        invoiceDiscountUntaxAmtSum: 0,
        paymentInvoiceTaxSum: 0,
        paymentInvoiceUntaxAmtSum: 0,
        paymentTaxSum: 0,
        paymentUntaxAmtSum: 0,
    },

    //
    declarePeriod: null,
    declarePeriodYear: null,
    declaredInvoiceItems: [],
    declaredPaymentItems: [],
    declaredQueryParams: {
        activeTab: 'Total',
        foo: null,
        buyBsn: null,
        saleBsn: null,
        amt: 0,
    },

    //
    step4DisplayMode: 'Table',
    step4MediaFileData: null,
};

const getters = {};

const mutations = {
    updateDeclaredQueryParams(state, query) {
        state.declaredQueryParams.activeTab = query?.activeTab || state.declaredQueryParams.activeTab;
        state.declaredQueryParams.foo = _.toUpper(query?.foo);
        state.declaredQueryParams.buyBsn = query?.buyBsn;
        state.declaredQueryParams.saleBsn = query?.saleBsn;
        state.declaredQueryParams.amt = query?.amt;
    },

    setDeclarePeriod(state, data) {
        state.declarePeriod = data.value;
        state.declarePeriodYear = data.year;
        $router.replace({
            query: {
                period: Number($router.currentRoute.query.period),
                periodYear: Number($router.currentRoute.query.periodYear),
                SearchType: Number($router.currentRoute.query.SearchType),
                QueryType: Number($router.currentRoute.query.QueryType),
                TaxDeclareStatus: Number($router.currentRoute.query.TaxDeclareStatus),
                startDate: $router.currentRoute.query.startDate ? Number($router.currentRoute.query.startDate) : undefined,
                endDate: $router.currentRoute.query.endDate ? Number($router.currentRoute.query.endDate) : undefined,
                declarePeriod: state.declarePeriod,
                declarePeriodYear: state.declarePeriodYear,
            },
        });
    },
    setPeriod(state, data) {
        state.period = data;
    },
    setTimespan(state, data) {
        state.timespan = data;
    },
    setStep4DisplayMode(state, data) {
        state.step4DisplayMode = data;
    },
    setStep4MediaFileData(state, data) {
        state.step4MediaFileData = data;
    },
    setDataStatistic(state, data) {
        state.dataStatistic.invoiceTaxSum = data.invoiceTaxSum;
        state.dataStatistic.invoiceUntaxAmtSum = data.invoiceUntaxAmtSum;
        state.dataStatistic.invoiceDiscountTaxSum = data.invoiceDiscountTaxSum;
        state.dataStatistic.invoiceDiscountUntaxAmtSum = data.invoiceDiscountUntaxAmtSum;
        state.dataStatistic.paymentTaxSum = data.paymentTaxSum;
        state.dataStatistic.paymentUntaxAmtSum = data.paymentUntaxAmtSum;
        state.dataStatistic.paymentInvoiceTaxSum = data.paymentInvoiceTaxSum;
        state.dataStatistic.paymentInvoiceUntaxAmtSum = data.paymentInvoiceUntaxAmtSum;
    },

    // ======================================================================

    resetLocalStorage() {
        window.localStorage.removeItem('401-selected-invoice');
        window.localStorage.removeItem('401-selected-payment');
    },

    updateQuery(state, query) {
        console.log('state', state);
        console.log('query', query);
        if (query?.period === 0) {
            state.period = null;
            state.periodYear = null;
        }
        state.period = query?.period?.value || state.period;
        state.periodYear = query?.period?.year || state.periodYear;
        state.queryParams.SearchType = query?.SearchType || state.queryParams.SearchType;
        state.queryParams.QueryType = query?.QueryType || state.queryParams.QueryType;
        state.timespan = state?.period ? getTimeSpanByPeriod(state.periodYear, state.period, query?.Year) : query?.timespan || state.timespan;
        state.queryParams.StartDate = Number(_.head(state.timespan)) || state.queryParams.StartDate;
        state.queryParams.EndDate = Number(_.last(state.timespan)) || state.queryParams.EndDate;
        state.queryParams.Year = state.queryParams.SearchType === 1 ? null : Number(state.periodYear) || state.queryParams.Year;
        state.queryParams.Month = state.queryParams.SearchType === 1 ? null : query?.period?.value || state.period;
        state.queryParams.Foo = query?.Foo;
        state.queryParams.Bsn = query?.Bsn ? query?.Bsn : null;
        state.queryParams.Amt = query?.Amt ? query?.Amt : null;
        state.queryParams.TaxDeclareStatus = query?.TaxDeclareStatus || state.queryParams.TaxDeclareStatus;

        console.log('updateQuery', state.queryParams);

        const [startDate, endDate] = state.timespan;
        if (
            state.period
            && !(
                state.period === Number($router.currentRoute.query.period)
                && state.queryParams.SearchType === Number($router.currentRoute.query.SearchType)
                && state.queryParams.QueryType === Number($router.currentRoute.query.QueryType)
                && state.queryParams.TaxDeclareStatus === Number($router.currentRoute.query.TaxDeclareStatus)
            )
        ) {
            $router.replace({
                query: {
                    period: state.period,
                    periodYear: state.periodYear,
                    SearchType: state.queryParams.SearchType,
                    QueryType: state.queryParams.QueryType,
                    TaxDeclareStatus: state.queryParams.TaxDeclareStatus,
                    declarePeriod: state.declarePeriod,
                    declarePeriodYear: state.declarePeriodYear,
                },
            });
        } else if (
            !state.period
            && !(
                startDate === Number($router.currentRoute.query.startDate)
                && endDate === Number($router.currentRoute.query.endDate)
                && state.queryParams.SearchType === Number($router.currentRoute.query.SearchType)
                && state.queryParams.QueryType === Number($router.currentRoute.query.QueryType)
                && state.queryParams.TaxDeclareStatus === Number($router.currentRoute.query.TaxDeclareStatus)
            )
        ) {
            $router.replace({
                query: {
                    startDate,
                    endDate,
                    SearchType: state.queryParams.SearchType,
                    QueryType: state.queryParams.QueryType,
                    TaxDeclareStatus: state.queryParams.TaxDeclareStatus,
                    declarePeriod: state.declarePeriod,
                    declarePeriodYear: state.declarePeriodYear,
                },
            });
        }

        if (state.declarePeriod && state.declarePeriod !== Number($router.currentRoute.query.declarePeriod)) {
            $router.replace({
                query: {
                    period: Number($router.currentRoute.query.period),
                    periodYear: Number($router.currentRoute.query.periodYear),
                    SearchType: Number($router.currentRoute.query.SearchType),
                    QueryType: Number($router.currentRoute.query.QueryType),
                    TaxDeclareStatus: Number($router.currentRoute.query.TaxDeclareStatus),
                    startDate: $router.currentRoute.query.startDate ? Number($router.currentRoute.query.startDate) : undefined,
                    endDate: $router.currentRoute.query.endDate ? Number($router.currentRoute.query.endDate) : undefined,
                    declarePeriod: state.declarePeriod,
                    declarePeriodYear: state.declarePeriodYear,
                },
            });
        }
    },

    // Pagination sync functions

    syncPageSize(state, num) {
        state.queryParams.PageSize = num;
    },
    syncPageNum(state, num) {
        state.queryParams.PageNum = num;
    },
    syncTotalDataCount(state, num) {
        state.totalDataCount = num;
    },

    // selection change
    setCurrentTableVueComponent(state, vueComponent) {
        state.currentTableVueComponent = vueComponent;
    },
    onClearInvoiceSelection(state) {
        state.selectedInvoiceItems = [];
        window.localStorage.removeItem('401-selected-invoice');
    },
    onClearPaymentSelection(state) {
        state.selectedPaymentItems = [];
        window.localStorage.removeItem('401-selected-payment');
    },
    onClearSelection(state) {
        state.selectedItems = [];
        state.selectedInvoiceItems = [];
        state.selectedPaymentItems = [];

        window.localStorage.removeItem('401-selected-invoice');
        window.localStorage.removeItem('401-selected-payment');
    },
    onSelectAll(state, selection) {
        if (selection.length === 0) {
            console.log('CANCEL SELECT ALL');

            if (state.queryParams.QueryType === 1) {
                state.datas.forEach((item) => {
                    const INDEX = state.selectedInvoiceItems.findIndex((o) => o.sno === item.sno && o.typ === item.typ);
                    if (INDEX >= 0) state.selectedInvoiceItems.splice(INDEX, 1);
                });
                window.localStorage.setItem('401-selected-invoice', JSON.stringify(state.selectedInvoiceItems));
            } else {
                state.datas.forEach((item) => {
                    const INDEX = state.selectedPaymentItems.findIndex((o) => o.sno === item.sno && o.typ === item.typ);
                    if (INDEX >= 0) state.selectedPaymentItems.splice(INDEX, 1);
                });
                window.localStorage.setItem('401-selected-payment', JSON.stringify(state.selectedPaymentItems));
            }

            state.selectedItems = [...state.selectedInvoiceItems, ...state.selectedPaymentItems];
        } else if (state.datas.length) {
            console.log('SELECT ALL');

            if (state.queryParams.QueryType === 1) {
                const DIFF = _.differenceWith(selection, state.selectedInvoiceItems, (x, y) => x.sno === y.sno && x.typ === y.typ);
                DIFF.forEach((item) => {
                    state.selectedInvoiceItems.push(item);
                });
                window.localStorage.setItem('401-selected-invoice', JSON.stringify(state.selectedInvoiceItems));
            } else {
                const DIFF = _.differenceWith(selection, state.selectedPaymentItems, (x, y) => x.sno === y.sno && x.typ === y.typ);
                DIFF.forEach((item) => {
                    state.selectedPaymentItems.push(item);
                });
                window.localStorage.setItem('401-selected-payment', JSON.stringify(state.selectedPaymentItems));
            }

            state.selectedItems = [...state.selectedInvoiceItems, ...state.selectedPaymentItems];
        }
    },
    onSelect(state, selection) {
        if (state.queryParams.QueryType === 1) {
            const ONBOARD = [];
            state.datas.forEach((item) => {
                const FOUND = _.find(state.selectedInvoiceItems, (o) => o.sno === item.sno && o.typ === item.typ);
                if (FOUND) ONBOARD.push(FOUND);
            });

            const ADD = _.differenceWith(selection, ONBOARD, (x, y) => x.sno === y.sno && x.typ === y.typ);
            const MINUS = _.differenceWith(ONBOARD, selection, (x, y) => x.sno === y.sno && x.typ === y.typ);

            if (ADD[0]) {
                console.log('ADD');
                state.selectedInvoiceItems.push(ADD[0]);
            } else if (MINUS[0]) {
                console.log('DELETE');
                const INDEX = state.selectedInvoiceItems.findIndex((o) => o.sno === MINUS[0].sno && o.typ === MINUS[0].typ);
                if (INDEX >= 0) state.selectedInvoiceItems.splice(INDEX, 1);
            }
            window.localStorage.setItem('401-selected-invoice', JSON.stringify(state.selectedInvoiceItems));
        } else {
            const ONBOARD = [];
            state.datas.forEach((item) => {
                const FOUND = _.find(state.selectedPaymentItems, (o) => o.sno === item.sno && o.typ === item.typ);
                if (FOUND) ONBOARD.push(FOUND);
            });

            const ADD = _.differenceWith(selection, ONBOARD, (x, y) => x.sno === y.sno && x.typ === y.typ);
            const MINUS = _.differenceWith(ONBOARD, selection, (x, y) => x.sno === y.sno && x.typ === y.typ);

            if (ADD[0]) {
                console.log('ADD');
                state.selectedPaymentItems.push(ADD[0]);
            } else if (MINUS[0]) {
                console.log('DELETE');
                const INDEX = state.selectedPaymentItems.findIndex((o) => o.sno === MINUS[0].sno && o.typ === MINUS[0].typ);
                if (INDEX >= 0) state.selectedPaymentItems.splice(INDEX, 1);
            }
            window.localStorage.setItem('401-selected-payment', JSON.stringify(state.selectedPaymentItems));
        }

        state.selectedItems = [...state.selectedInvoiceItems, ...state.selectedPaymentItems];
    },
    resetStates(state) {
        state.isLoading = false;
        state.datas = [];
        state.periodList = [];

        // Queries
        state.timespan = null;
        state.period = null;
        state.periodYear = null;
        state.keyword = null;
        state.totalDataCount = 0;
        state.queryParams = {
            SearchType: 1, // 1: 發票日期, 2: 申報日期
            QueryType: 1, // 1: 發票收入(銷項), 2: 請款支出(進項)
            StartDate: null,
            EndDate: null,
            PageSize: 25,
            PageNum: 1,
            Year: null,
            Month: null,
            Foo: null,
            Bsn: null,
            Amt: null,
            TaxDeclareStatus: 1,
        };

        //
        state.currentTableVueComponent = null;
        state.selectedItems = [];
        state.selectedInvoiceItems = [];
        state.selectedPaymentItems = [];

        //
        state.dataCount = {
            undeclared: 0,
            declared: 0,
            other1: 0,
            other2: 0,
        };

        //
        state.declarePeriod = null;
        state.declarePeriodYear = null;
        state.declaredInvoiceItems = [];
        state.declaredPaymentItems = [];
        state.declaredQueryParams = {
            activeTab: 'Total',
            foo: null,
            buyBsn: null,
            saleBsn: null,
            amt: 0,
        };

        //
        state.step4DisplayMode = 'Table';
        state.step4MediaFileData = null;
    },
    emptyStateData(state) {
        state.datas = []; // clear
    },
};

const actions = {
    async init({ state, commit, dispatch }) {
        commit('resetStates');

        for (let i = 0; i < 36; i += 2) {
            const TODAY = moment();
            const CALCULATED_TIME = TODAY.subtract(i, 'month');
            const PERIOD = Math.floor(CALCULATED_TIME.month() / 2) + 1;
            state.periodList.push({
                key: `${CALCULATED_TIME.year()}-${PERIOD}`,
                year: CALCULATED_TIME.year(),
                period: `${PERIOD * 2 - 1}～${PERIOD * 2}月`,
                months: [PERIOD * 2 - 1, PERIOD * 2],
                value: PERIOD,
            });
        }

        if (!_.isEmpty($router.currentRoute.query)) {
            // 使用網址query匯入資料
            const period = Number($router.currentRoute.query.period);
            const periodYear = Number($router.currentRoute.query.periodYear);
            const startDate = Number($router.currentRoute.query.startDate);
            const endDate = Number($router.currentRoute.query.endDate);
            state.queryParams.SearchType = Number($router.currentRoute.query.SearchType);
            state.queryParams.QueryType = Number($router.currentRoute.query.QueryType);
            state.queryParams.TaxDeclareStatus = Number($router.currentRoute.query.TaxDeclareStatus);
            state.declarePeriod = $router.currentRoute.query.declarePeriod ? Number($router.currentRoute.query.declarePeriod) : undefined;
            state.declarePeriodYear = $router.currentRoute.query.declarePeriodYear ? Number($router.currentRoute.query.declarePeriodYear) : undefined;

            if (period && periodYear) {
                state.period = period;
                state.periodYear = periodYear;
            } else if (moment(startDate).isValid() && moment(endDate).isValid()) state.timespan = [startDate, endDate];
            else {
                $router.replace({ query: {} });
                state.period = _.head(state.periodList).value;
            }
        } else {
            // 預設本期期別
            state.period = _.head(state.periodList).value;
            state.periodYear = moment().year();
        }

        commit('updateQuery');
        await dispatch('updateData');

        state.isReady = true;
    },
    emptyData({ commit }) {
        commit('emptyStateData');
    },
    async updateData({ state, commit }, updateQuery) {
        if (updateQuery) commit('updateQuery');

        try {
            state.isLoading = true;

            const params = { ...state.queryParams };

            if (state.queryParams.SearchType === 1) {
                params.Year = null;
                params.Month = null;
            } else {
                params.Year = state.queryParams.Year;
                params.Month = state.queryParams.Month;
                params.StartDate = null;
                params.EndDate = null;
            }

            const resp = await $api({
                url: 'AccountingSummaryPage/Query401',
                params: {
                    ...params,
                    QueryType: params.QueryType === 2 || params.QueryType === 3 ? 2 : 1,
                    SearchType: undefined,
                },
                method: 'GET',
            });

            const INVOICE_RESP = resp.data.invoiceResult || [];
            let invoiceResult = INVOICE_RESP.map((item) => (item.typ > 0
                ? {
                    ...item,
                    amt: item.foO_DIS_CNL || item.foO_CNL ? 0 : Math.round(item.amt * (item.rat || 1)),
                    amT_TAX: item.foO_DIS_CNL || item.foO_CNL ? 0 : Math.round(item.amT_TAX * (item.rat || 1)),
                    foO_DIS_AMT: Math.round(item.foO_DIS_AMT * (item.rat || 1)),
                }
                : {
                    ...item,
                    amt: item.foO_DIS_CNL || item.foO_CNL ? 0 : Math.round(item.foO_DIS_AMT * (item.rat || 1)),
                    amT_TAX: item.foO_DIS_CNL || item.foO_CNL ? 0 : Math.round(item.foO_DIS_AMT_TAX * (item.rat || 1)),
                    foO_DIS_AMT: Math.round(item.foO_DIS_AMT * (item.rat || 1)),
                    prefiX_MONTH: item.foO_DIS_PREFIX_MONTH,
                    prefiX_YEAR: item.foO_DIS_PREFIX_YEAR,
                    orI_FOO_DAT: item.foO_DAT,
                    foO_DAT: item.foO_DIS_DAT,
                    code: getDiscountValidateCode(item.foo, item.foO_DAT),
                }));

            const PAYMENT_RESP = resp.data.paymentResult || [];
            let paymentResult = [...PAYMENT_RESP];

            const PAYMENT_INVOICE_RESP = resp.data.paymentInvoiceResult || [];
            let paymentInvoiceResult = [
                ...PAYMENT_INVOICE_RESP.map((o) => ({
                    ...o,
                    companyName: o.sellerName,
                    taxCredited: true,
                })),
            ];

            if (state.keyword) {
                const keyRegex = new RegExp(state.keyword);
                invoiceResult = [...invoiceResult.filter((item) => item.foo?.match(keyRegex))];
                paymentResult = [...paymentResult.filter((item) => item.foo?.match(keyRegex))];
                paymentInvoiceResult = [...paymentInvoiceResult.filter((item) => item.foo?.match(keyRegex))];
            }

            console.log(invoiceResult);
            if (state.queryParams.QueryType === 1) {
                state.totalDataCount = resp.data.invoiceResultTotalNum;
                state.datas = invoiceResult;
                // 個數統計
                state.dataCount.undeclared = resp.data.countInvoiceResult.notDeclareCount;
                state.dataCount.declared = resp.data.countInvoiceResult.declaredCount;
                state.dataCount.other1 = resp.data.countInvoiceResult.zeroTaxRateCount;
                state.dataCount.other2 = resp.data.countInvoiceResult.exemptDeclareCount;
            } else if (state.queryParams.QueryType === 2) {
                state.totalDataCount = resp.data.paymentResultTotalNum;
                state.datas = paymentResult;
                // 個數統計
                state.dataCount.undeclared = resp.data.countPaymentResult.notDeclareCount;
                state.dataCount.declared = resp.data.countPaymentResult.declaredCount;
                state.dataCount.other1 = resp.data.countPaymentResult.zeroTaxRateCount;
                state.dataCount.other2 = resp.data.countPaymentResult.exemptDeclareCount;
            } else {
                state.totalDataCount = resp.data.paymentInvoiceResultTotalNum;
                state.datas = paymentInvoiceResult;
                // 個數統計
                state.dataCount.undeclared = resp.data.countPaymentInvoiceResult.notDeclareCount;
                state.dataCount.declared = resp.data.countPaymentInvoiceResult.declaredCount;
                state.dataCount.other1 = resp.data.countPaymentInvoiceResult.zeroTaxRateCount;
                state.dataCount.other2 = resp.data.countPaymentInvoiceResult.exemptDeclareCount;
            }
            // 金額統計
            commit('setDataStatistic', resp.data);
        } finally {
            state.isLoading = false;

            const LOCAL_INVOICE_DATA = JSON.parse(window.localStorage.getItem('401-selected-invoice')) || [];
            const LOCAL_PAYMENT_DATA = JSON.parse(window.localStorage.getItem('401-selected-payment')) || [];

            if (state.queryParams.QueryType === 1 && state.currentTableVueComponent) state.currentTableVueComponent.fetchSelection(LOCAL_INVOICE_DATA);
            else if (state.currentTableVueComponent) state.currentTableVueComponent.fetchSelection(LOCAL_PAYMENT_DATA);

            state.selectedInvoiceItems = [...LOCAL_INVOICE_DATA];
            state.selectedPaymentItems = [...LOCAL_PAYMENT_DATA];
            state.selectedItems = [...LOCAL_INVOICE_DATA, ...LOCAL_PAYMENT_DATA];
        }
    },
    async updateDeclaredData({ state }) {
        try {
            const params = { ...state.queryParams };

            if (state.queryParams.SearchType === 1) {
                params.Year = null;
                params.Month = null;
            } else {
                params.Year = state.queryParams.Year;
                params.Month = state.queryParams.Month;
                params.StartDate = null;
                params.EndDate = null;
            }

            const invoiceResp = await $api({
                url: 'AccountingSummaryPage/Query401',
                params: {
                    QueryType: 1,
                    PageSize: 9999,
                    PageNum: 1,
                    Year: state.declarePeriodYear,
                    Month: state.declarePeriod,
                },
                method: 'GET',
            });
            let invoiceResult = invoiceResp.data.invoiceResult.map((item) => (item.typ > 0
                ? {
                    ...item,
                    amt: item.foO_DIS_CNL || item.foO_CNL ? 0 : Math.round(item.amt * (item.rat || 1)),
                    amT_TAX: item.foO_DIS_CNL || item.foO_CNL ? 0 : Math.round(item.amT_TAX * (item.rat || 1)),
                    foO_DIS_AMT: Math.round(item.foO_DIS_AMT * (item.rat || 1)),
                }
                : {
                    ...item,
                    amt: item.foO_DIS_CNL || item.foO_CNL ? 0 : Math.round(item.foO_DIS_AMT * (item.rat || 1)),
                    amT_TAX: item.foO_DIS_CNL || item.foO_CNL ? 0 : Math.round(item.foO_DIS_AMT_TAX * (item.rat || 1)),
                    foO_DIS_AMT: Math.round(item.foO_DIS_AMT * (item.rat || 1)),
                    prefiX_MONTH: item.foO_DIS_PREFIX_MONTH,
                    prefiX_YEAR: item.foO_DIS_PREFIX_YEAR,
                    orI_FOO_DAT: item.foO_DAT,
                    foO_DAT: item.foO_DIS_DAT,
                    code: getDiscountValidateCode(item.foo, item.foO_DAT),
                }));
            invoiceResult = _.chain(invoiceResult)
                .sortBy('foO_DAT')
                .filter((item) => item.foo != null)
                .filter((item) => ((item.typ === 2 || item.typ === 3) && item.declared === true) || (item.typ === -1 && item.foO_DIS_Declared === true))
                .value();

            const paymentResp = await $api({
                url: 'AccountingSummaryPage/Query401',
                params: {
                    QueryType: 2,
                    PageSize: 9999,
                    PageNum: 1,
                    Year: state.declarePeriodYear,
                    Month: state.declarePeriod,
                },
                method: 'GET',
            });
            let paymentResult = [
                ...paymentResp.data.paymentResult,
                ...paymentResp.data.paymentInvoiceResult.map((o) => ({
                    ...o,
                    companyName: o.sellerName,
                    taxCredited: true,
                })),
            ];
            paymentResult = _.chain(paymentResult)
                .filter((item) => item.foo != null && (item.filE_TYP === 1 || item.filE_TYP === 2 || item.filE_TYP === 3 || item.filE_TYP === 10 || item.filE_TYP === 11) && item.declareStatus === 1)
                .value();

            // console.log('401 已申報', paymentResult, invoiceResult);

            state.declaredInvoiceItems = [...invoiceResult];
            state.declaredPaymentItems = [...paymentResult];
        } catch (e) {
            console.log(e);
        }
    },
};

export default {
    namespaced: true,
    state: states,
    getters,
    actions,
    mutations,
};
